import vmClient from '../../services/vmClient';
import { Entity, EntityFields, EntityStringId, IEntityType, IEntity } from './../../types/entity';
import { Point, PointMarshaller } from './Point';

export interface IImage extends IEntity {
  attributes: {
    attribution: string | null;
    dimensions: Point | null;
    id: EntityStringId;
    publicAttribution: boolean | null;
    url: string;
  };
}

export type ImageFields = EntityFields<IImage>;

export type Image = Entity<IImage>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Image: IEntityType<IImage> = vmClient.defineClass({
  typeName: 'Image',
  version: 2,
  lockable: true,
  persisted: true,
  attributes: {
    url: {
      type: 'string',
      notNull: true,
    },
    dimensions: {
      type: Point,
      marshaller: PointMarshaller,
    },
    attribution: 'string',
    publicAttribution: 'boolean',
  },
});
